import { render, staticRenderFns } from "./listProveedoresModal.vue?vue&type=template&id=2bfd8460&scoped=true"
import script from "./listProveedoresModal.vue?vue&type=script&lang=js"
export * from "./listProveedoresModal.vue?vue&type=script&lang=js"
import style0 from "./listProveedoresModal.vue?vue&type=style&index=0&id=2bfd8460&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bfd8460",
  null
  
)

export default component.exports